<template>
    <div>
        <modal :name="modal_name" class="final-modal edit-template" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header" style="background:#ffffff !important;">
                    <span class="v-modal-dialog-title v-modal-title text-dark" style="text-transform:none !important;">Edit Product Bug Template</span>
                    <span @click="hideView()">
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/close_template.svg" alt="" height="25px">
                    </span>
                </div>
                <div class="general-section pl-0 pr-0 pb-1" style="background-color:#ffffff;border-radius:0px">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 500px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                                    <div>
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Product<span class="text-danger pl-1">*</span></span>
                                        <div class="">
                                            <multiselect
                                                label="name"
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-4"
                                                name="product"
                                                data-vv-as="Product"
                                                v-model="product"
                                                :options="allProducts"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Product"
                                                :loading="product_loading" @search-change="getAllProduct"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfProduct" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('product')">{{ errors.first('product') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                                    <div>
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Creation type<span class="text-danger pl-1">*</span></span>
                                        <div class="">
                                            <multiselect
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-4"
                                                name="creation_type"
                                                v-model="creation_types"
                                                :options="creation_type_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Creation Type"
                                            >
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('creation_type')">{{ errors.first("creation_type") }}</span>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                                    <div>
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Issue Type</span>
                                        <div class="">
                                            <multiselect
                                                class="diginew-multiselect mt-4"
                                                name="type"
                                                v-model="type"
                                                :options="type_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                :hide-selected="true"
                                                placeholder="Select Type"
                                            >
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('type')">{{ errors.first("type") }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-8" v-if="show_priority">
                                    <div>
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Priority<span class="text-danger pl-1">*</span></span>
                                        <div class="">
                                            <multiselect
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-4"
                                                name="priority"
                                                v-model="priority"
                                                :options="priority_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Priority"
                                            >
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('priority')">{{ errors.first("priority") }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                                    <!-- <div class="w-100">
                                        <label class="inputLabel fs-14 fw-600 text-black">Tags <span class="text-danger pl-1">*</span></label>
                                        <input v-validate="'required'" name="tag" class="inputFieldNew" type="text" v-model="tags" placeholder="Add Tags" />
                                        <span class="inputBorder"></span>
                                        <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('tag')" style="display: inline !important">{{ errors.first("tag") }}</span>
                                    </div> -->
                                    <label class="inputLabel fs-14 fw-600 text-black">Tags </label>
                                    <vue-tags-input v-model="tag" class="mt-2" name="tags" id='tags' :tags="tags" @tags-changed="newTags => tags = newTags" />
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-8">
                                    <div>
                                        <span class="whiteSpace fs-14 fw-600 ml-2 text-capitalize">Is it functional bug ?<span class="text-danger pl-1">*</span></span>
                                        <div class="d-flex align-items-center mt-5 ml-2">
                                            <!-- <div class="d-flex align-items-center">
                                                <input type="radio" class="pointer" v-model="is_functional" value="true">
                                                <span class="pl-5 pointer">Yes</span>
                                            </div>
                                            <div class="d-flex align-items-center ml-7">
                                                <input type="radio" class="pointer" v-model="is_functional" value="false">
                                                <span class="pl-5 pointer">No</span>
                                            </div> -->
                                            <el-radio-group v-model="is_functional">
                                                <el-radio :label="true">
                                                    Yes
                                                </el-radio>
                                                <el-radio :label="false">
                                                    No
                                                </el-radio>
                                            </el-radio-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" :disabled="is_api_in_progress" style="box-shadow: none;" @click="validateNext()">
                            SAVE
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import scm from '../mixins/scm.js';
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue'
import VueTagsInput from "@johmun/vue-tags-input";
import setting from '../mixins/setting.js';
export default {
    props:['modal_name','ticket_id','template_id','source'],
    mixins:[scm,ticket, setting],
    components:{
        SweetModal,
        VueTagsInput
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            is_api_in_progress:false,
            product_loading:false,
            product_scrollable:false,
            product_count:0,
            allProducts:[],
            product:'',
            temp_allProducts:[],
            product_visible:false,
            creation_type_options:['Email', 'Others', 'Phone','Social Media'],
            creation_types:'',
            type_options:['Bug', 'Crashes', 'Help', 'Incident', 'New Feature','Request'],
            type:'Incident',
            priority_options:['High','Low', 'Medium'],
            priority:'Medium',
            tag:'',
            tags:[],
            is_functional:true,
            api_response:{},
            show_priority: false,
        }
    },
    methods:{
        hideView(){
            this.$modal.hide(this.modal_name);
            this.$emit('hideSBR')
        },
        async getAllProduct(search_key){
            try {
                this.product_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key,
                    // customer_id:this.crm_customer_id
                }
                let res = await this.getSCMProducts(params)
                this.allProducts = res.response.products
                this.product_count = this.temp_allProducts.length
                this.product_loading = false
                this.product_scrollable = false
            } catch (reason) {
                
            }
        },
        async reachedEndOfProduct(reached){
            this.product_visible = reached
            if (reached) {
                if (this.product_scrollable == false) {
                    this.product_loading = true
                    let params ={
                        skip:this.product_count,
                        limit:10,
                        search_key:this.search_key,
                        // customer_id:this.crm_customer_id
                    }
                    let response = await this.getSCMProducts(params)
                    this.temp_allProducts = response.response.products.length;
                    if (response.response.skip == this.product_count) {
                        if (this.temp_allProducts > 0) {
                            let tempFiles = response.response.products;
                            tempFiles.forEach(el => {
                                this.allProducts.push(el);
                            });
                            this.product_count += response.response.products.length;
                            this.product_loading = false
                        } else {
                            this.product_scrollable = true
                            this.product_loading = false
                        }
                    }
                    this.product_loading = false
                }
            }
        },
        async getIsShowPriority() {
            let param = {
                settings_type: ['display_ticket_priorities']
            }
            let data = await this.getAllJobTypes(param);
            this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
        },
        async getDetails(){
            try {
                let params = {
                    ticket_id:this.ticket_id,
                    template_id:this.template_id
                }
                let res = await this.getTicketData(params)
                this.api_response = res.response.template_data['Product Bug Template']
                this.product = this.api_response.products,
                this.creation_types = this.api_response.creation_type == 'social_media' ? 'Social Media' : this.api_response.creation_type
                this.type = this.api_response.type == 'new_feature' ? 'New Feature' : this.api_response.type
                this.priority = this.api_response.priority
                this.api_response.tags.forEach(el=> {
                    this.tags.push({
                        text: el
                    })
                })
                this.is_functional = this.api_response.is_functional
            }catch (reason) {
                
            }
        },
        validateNext(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    if(this.source == 'draft'){
                        this.is_validated = true
                        this.create_json.tags.forEach((el,index)=>{
                            this.create_json.tags[index] = el.text;
                            delete el.text
                        })
                        this.confirmSaveDraft()
                    }else{
                        this.create_json.tags.forEach((el,index)=>{
                            this.create_json.tags[index] = el.text;
                            delete el.text
                        })
                        this.confirmSave()
                    }
                }else if(!result){
                    this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmSave(params){
            this.is_api_in_progress = true
            try {
                let res = await this.editTicket(this.create_json)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('saveEditSBR')
                    this.hideView()
                }, 2000);
            } catch (reason) {
                this.is_api_in_progress = false
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
            }
        },
        async confirmSaveDraft(){
            try {
                let res = await this.draftUpdate(this.save_draft_json)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('saveEditSBR')
                    this.hideView()
                }, 2000);
            } catch (reason) {
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
            }
        },
        async getDetailsDraft(){
            try {
                let params = {
                    draft_ticket_id:this.ticket_id,
                    draft_template_id:this.template_id
                }
                let res = await this.getDraftData(params)
                this.api_response = res.response.template_data
                this.product = this.api_response.products,
                this.creation_types = this.api_response.creation_type == 'social_media' ? 'Social Media' : this.api_response.creation_type
                this.type = this.api_response.type == 'new_feature' ? 'New Feature' : this.api_response.type
                this.priority = this.api_response.priority
                if(this.api_response.tags.length) {
                    this.api_response.tags.forEach(el=> {
                        this.tags.push({
                            text: el
                        })
                    })
                }
                this.is_functional = this.api_response.is_functional
            }catch (reason) {
                
            }
        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        create_json(){
            return{
                priority:this.priority,
                products: this.product[0] ? this.product[0]._id : this.product._id,
                creation_type:this.creation_types == 'Social Media' ? 'social_media' : this.creation_types.toLowerCase(),
                is_functional:this.is_functional,
                type:this.type == 'New Feature' ? 'new_feature' : this.type.toLowerCase(),
                tags:this.tags,
                template_id:this.template_id,
                ticket_id:this.ticket_id,
            }
        },
        save_draft_json(){
            return{
                priority:this.priority,
                products:this.product[0]._id,
                creation_type:this.creation_types == 'Social Media' ? 'social_media' : this.creation_types.toLowerCase(),
                is_functional:this.is_functional,
                type:this.type == 'New Feature' ? 'new_feature' : this.type.toLowerCase(),
                tags:this.tag,
                draft_template_id:this.template_id,
                draft_ticket_id:this.ticket_id,
            }
        }
        // capitalize(string) {
        //     return string.charAt(0).toUpperCase() + string.slice(1);
        // }
    },
    mounted(){
        this.getIsShowPriority();
        if(this.source == 'draft'){
            this.getDetailsDraft()
        }else{
            this.getDetails()
        }
    },
    created(){
        const dict = {
            custom: {
                product:{
                    required:() => "Product is Required",
                },
                type:{
                    required:() => "Type is Required",
                },
                priority:{
                    required:() => "Priority is Required",
                },
                creation_type:{
                    required:() => "Creation Type is Required",
                },
                tag:{
                    required:() => "Tags is Required",
                }
            }
        }
        this.$validator.localize("en", dict); 
    }

}
</script>

<style scoped>

</style>